import { useState } from 'react'
import styled from '@emotion/styled'
import useFlow from 'modules/flow/state/use-flow'
import useOrder from '../../../order/state/order/use-order'
import { TextArea } from '../../../ui/atoms/TextArea'
import { DEFAULT_THEME_COLORS } from '../../../../css/theme'
import FlowOneColumnStepLayout from '../one-column-step-layout/one-column-step-layout'
import { MainOuter } from '../one-column-step-layout/one-column-step-layout.styled'
import {
  trackFormSkipEvent,
  trackFormSubmitEvent,
} from '../../../analytics/helpers/track-form-events'
import useConfig from '../../../config/state/use-config'
import { useTranslation } from 'next-i18next'

const MAX_COMMENT_LENGTH = 1000

const CommentStep = () => {
  const flow = useFlow()
  const order = useOrder()
  const config = useConfig()
  const { t } = useTranslation()

  const primaryColor =
    config.theme['--theme-color__brand-primary'] ||
    DEFAULT_THEME_COLORS['--theme-color--neutral-10']

  const [draft, setDraft] = useState(order.comment.value)

  const goNext = () => {
    trackFormSubmitEvent(flow.currentStep.name)

    flow.nextStep && flow.goToStep(flow.nextStep.name)
  }

  const onSkip = () => {
    trackFormSkipEvent(flow.currentStep.name)

    goNext()
  }

  const onSubmit = () => {
    order.comment.save(draft)
    order.comment.setValue(draft)

    goNext()
  }

  return (
    <MainOuter>
      <FlowOneColumnStepLayout.Main
        title={flow.currentStep.title}
        backButtonDataId="comment-step-back-button"
      >
        <TextAreaWrapper>
          <TextArea
            autoFocus
            tabIndex={0}
            maxLength={MAX_COMMENT_LENGTH}
            value={draft}
            onChange={setDraft}
            dataId="comment-step-textarea"
          />
        </TextAreaWrapper>
      </FlowOneColumnStepLayout.Main>
      <FlowOneColumnStepLayout.Footer>
        <FlowOneColumnStepLayout.FooterButton
          size="lg"
          onClick={onSkip}
          color={DEFAULT_THEME_COLORS['--theme-color--neutral-100']}
          borderColor={DEFAULT_THEME_COLORS['--theme-color--neutral-80']}
          dataId="comment-step-skip-button"
        >
          {t('CommentStep.skipButton.label', 'Skip')}
        </FlowOneColumnStepLayout.FooterButton>
        <FlowOneColumnStepLayout.FooterButton
          size="lg"
          onClick={onSubmit}
          disabled={draft.length > MAX_COMMENT_LENGTH}
          color={primaryColor}
          dataId="comment-step-continue-button"
        >
          {t('CommentStep.continueButton.label', 'Continue')}
        </FlowOneColumnStepLayout.FooterButton>
      </FlowOneColumnStepLayout.Footer>
    </MainOuter>
  )
}

export default CommentStep

const TextAreaWrapper = styled.div`
  width: 460px;

  div,
  textarea {
    width: 100%;
  }
`
